<template>
  <el-dialog
    :title="dname"
    :visible.sync="dialogFormVisible"
    custom-class="medium-dialog"
    :modal="true" center
    :close-on-click-modal="false">
    <el-table :data="tableData" border style="width: 100%">

      <!-- 类别 -->
      <el-table-column prop="paymethod" label="类别" align="left" width="80" />

      <!-- 备注 -->
      <el-table-column label="备注" align="left" width="90">
        <template #default="scope">
          {{ scope.row.relationpay ? '线上收款' : '' }}
        </template>
      </el-table-column>
      <!-- 收款账户 -->
      <el-table-column prop="orgname" label="收款账户" align="left" show-overflow-tooltip />


      <!-- 卡号 -->
      <el-table-column prop="mid" label="卡号" align="left" width="200" />
      <!-- 启用状态 -->
      <el-table-column label="启用状态" align="center" width="120">
        <template #default="scope">
          <el-switch
            v-model="scope.row.enabled"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {listunionpay,updateunionpay} from '@/api/set/dept';

  export default {
    name: "UnionpayTable",
    data() {
      return {
        dialogFormVisible: false,
        dname:'',
        dserial:'',
        dtenantid:'',
        tableData: []
      }
    },
    methods: {
      show(dname, dserial, dtenantid) {
        this.dname = dname;
        this.dserial = dserial;
        this.dtenantid = dtenantid || '';
        this.dialogFormVisible = true;
        this.bindGrid();
      },
      bindGrid() {
        listunionpay({stores: this.dserial, tenantid: this.dtenantid}).then(responseDept => {
          this.tableData = responseDept.data.obj;
        })
      },
      handleStatusChange(row) {
        updateunionpay({
          id: row.id,
          stores: this.dserial,
          tenantid: this.dtenantid,
          enabled: row.enabled // 1 或 0
        }).then(response => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          })
        })
      }
    },
    components: {
    }

  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }
</style>



// WEBPACK FOOTER //
// src/components/set/dept/UnionpayTable.vue